import {translateService} from "../../services/TranslateService";
import styles from "./VehicleSearch.module.scss";
import Modal from "react-modal";
import * as React from "react";
import {useContext, useState} from "react";
import {DataContext} from "../../contexts/dataContext";
import {IVehicleSearch} from "../../interfaces/VehicleSearch";
import {useSelector} from "react-redux";
import {GlobalStore} from "../../reduxStore";
import { CircularProgress } from '@mui/material';
import {cStylesMakeRes} from "../../CustomModalStyles";
import { buildVehicleItem } from "../../services/ga4Ecommerce";
import { normalizeCouponCode } from "../../services/couponCode";

interface VipCodeVehiclesProps {
    isVipVehicle: boolean,
    setVipCodeValid: Function,
    vehicle: IVehicleSearch,
    selectVehicle: Function,
    vipCodeCheckOpen: boolean,
    setVipCodeCheckOpen: Function,
}

export const VipCodeVehicles = ({isVipVehicle, setVipCodeValid, vehicle,
                                    selectVehicle, vipCodeCheckOpen, setVipCodeCheckOpen}: VipCodeVehiclesProps) => {
    const dataContext = useContext(DataContext);
    const apiService = useSelector((state: GlobalStore) => state.chauffeurReducer.apiService);
    const [vipCode, setVipCode] = useState<string>('');
    const [vipCodeError, setVipCodeError] = useState<string>('');
    const [busyValidating, setBusyValidating] = useState(false);

    const validateVipCode = (rawCode: string) => {
        // VIP codes share the coupon namespace — normalise so reporting sees one code
        const code = normalizeCouponCode(rawCode);
        setTimeout(() => {
            // timeout ensure busy state updates to show that api call was initialised (it is usually very quick for this api res)
            try{
                apiService?.vehicle.searchWithParams({...dataContext.searchParameters, carId: vehicle?.id, discount: code}, !!dataContext.loggedIn).then((res) => {
                    if(res.count === 1 && res.vehicles[0]?.privateData?.private === false) {
                        setVipCodeError('');
                        setVipCodeValid(true);
                        dataContext.changeValidatedVipVehicles(vehicle.id);
                        setVipCodeCheckOpen(false);
                        selectVehicle(res.vehicles[0]); // select vehicle if code is valid
                        dataContext.changeCouponCode(code);
                        dataContext.changeCouponDescription('vip')
                        dataContext.changeStoredCoupon({valid: true, code: code, description: 'vip'});
                        dataContext.changeSearchParameters({...dataContext.searchParameters, discount: code});
                        !dataContext.oneWayRes ?
                            dataContext.sendGa4Event("select_item", {
                                item_list_id: "a2a_list",
                                item_list_name: "A2A Results",
                                selection_surface: "list",
                                items: [buildVehicleItem(res.vehicles[0], { noVat: dataContext.noVatPrices })]
                            }) :
                            dataContext.sendGa4Event("select_item", {
                                item_list_id: "oneway_list",
                                item_list_name: "OneWay Results",
                                selection_surface: "list",
                                items: [buildVehicleItem(res.vehicles[0], { noVat: dataContext.noVatPrices })]
                            });
                    } else {
                        setVipCodeError(translateService.translate('vehicleSearch1.invalidCode'));
                    }
                }).finally(() => {
                    setBusyValidating(false);
                })
            } catch (e) {
                setVipCodeError(translateService.translate('vehicleSearch.errorLoadingResults'));
                setBusyValidating(false);
                if (dataContext.appContext !== "production") console.log(e);
            }
        }, 200)
    }

    return (
        <div> {
            isVipVehicle ? <Modal style={Object.assign(cStylesMakeRes)} isOpen={vipCodeCheckOpen}>
                    {busyValidating ?
                        <div className="d-flex justify-content-center my-2 pb-3 pt-2">
                            <CircularProgress color={"warning"}/>
                        </div>
                        :
                        <div>
                            <div className='icon-top-heading text-dark'>
                                {translateService.translate('vehicleSearch1.enterVipCode')}
                            </div>
                            <hr />
                            <input className={styles.vipCodeInput} type={"text"} value={vipCode}
                                   onChange={(e) => {setVipCode(normalizeCouponCode(e.target.value));
                                       if(vipCodeError) { setVipCodeError('')}}}/>
                            <div className={styles.vipCodeError} > {vipCodeError.length ? <span> {vipCodeError} </span> : null} </div>
                            <div className={styles.vipModalButtons}>
                                <button onClick={() => {setVipCode(''); setVipCodeError(''); setVipCodeCheckOpen(false)}}
                                        className='btn btn-primary btn-all btn-block mt-2' style={{marginRight: 10}}>{translateService.translate('vehicleSearch1.cancel')}</button>
                                <button onClick={() => {vipCode.length < 5 || vipCode.length > 15 ? setVipCodeError(translateService.translate('vehicleSearch1.invalidCode')) :
                                    setBusyValidating(true); validateVipCode(vipCode);}} className='btn btn-primary btn-all btn-block mt-2'>{translateService.translate('vehicleSearch1.send')}</button>
                            </div>
                        </div>
                    }
                </Modal>
                : null }
        </div>
    )
};


interface VipCodeFromMapProps {
    vehicle?: IVehicleSearch,
    selectVehicle: Function, vipCodeCheckOpen: boolean,
    setVipCodeCheckOpen: Function,
    clearSelectedVehicle: Function
}

// opening Vip Code Modal through map card is used slight differently hence it has a separated component
export const VipCodeFromMap = ({vehicle, selectVehicle, vipCodeCheckOpen, setVipCodeCheckOpen, clearSelectedVehicle}: VipCodeFromMapProps) => {
    const dataContext = useContext(DataContext);
    const apiService = useSelector((state: GlobalStore) => state.chauffeurReducer.apiService);
    const [vipCode, setVipCode] = useState<string>('');
    const [vipCodeError, setVipCodeError] = useState<string>('');
    const [busyValidating, setBusyValidating] = useState(false);

    const validateVipCode = (rawCode: string) => {
        // VIP codes share the coupon namespace — normalise so reporting sees one code
        const code = normalizeCouponCode(rawCode);
        setTimeout(() => {
            try{
                apiService?.vehicle.searchWithParams({...dataContext.searchParameters, carId: vehicle?.id, discount: code}, !!dataContext.loggedIn).then((res) => {
                    if(res.count === 1 && res.vehicles[0]?.privateData?.private === false) {
                        setVipCodeError('');
                        dataContext.changeValidatedVipVehicles(vehicle?.id);
                        setVipCodeCheckOpen(false);
                        clearSelectedVehicle();
                        selectVehicle(res.vehicles[0]); // select vehicle if code is valid
                        dataContext.changeCouponCode(code);
                        dataContext.changeCouponDescription('vip')
                        dataContext.changeStoredCoupon({valid: true, code: code, description: 'vip'});
                        dataContext.changeSearchParameters({...dataContext.searchParameters, discount: code});
                        !dataContext.oneWayRes ?
                            dataContext.sendGa4Event("select_item", {
                                item_list_id: "a2a_list",
                                item_list_name: "A2A Results",
                                selection_surface: "list",
                                items: [buildVehicleItem(res.vehicles[0], { noVat: dataContext.noVatPrices })]
                            }) :
                            dataContext.sendGa4Event("select_item", {
                                item_list_id: "oneway_list",
                                item_list_name: "OneWay Results",
                                selection_surface: "list",
                                items: [buildVehicleItem(res.vehicles[0], { noVat: dataContext.noVatPrices })]
                            });
                    } else {
                        setVipCodeError(translateService.translate('vehicleSearch1.invalidCode'));
                    }
                }).finally(() => {
                    setBusyValidating(false);
                })
            } catch (e) {
                setVipCodeError(translateService.translate('vehicleSearch.errorLoadingResults'));
                setBusyValidating(false);
                if (dataContext.appContext !== "production") console.log(e);
            }
        }, 200)
    }

    return (
        <div>
            {vehicle ?
                <Modal style={Object.assign(cStylesMakeRes)} isOpen={vipCodeCheckOpen}>
                    { busyValidating ?
                        <div className="d-flex justify-content-center my-2 pb-3 pt-2">
                            <CircularProgress color={"warning"}/>
                        </div>
                        :
                        <div>
                            <div className='icon-top-heading text-dark'>
                                {translateService.translate('vehicleSearch1.enterVipCode')}
                            </div>
                            <hr />
                            <input className={styles.vipCodeInput} type={"text"} value={vipCode}
                                   onChange={(e) => {setVipCode(normalizeCouponCode(e.target.value));
                                       if(vipCodeError) { setVipCodeError('')}}}/>
                            <div className={styles.vipCodeError} > {vipCodeError.length ? <span> {vipCodeError} </span> : null} </div>
                            <div className={styles.vipModalButtons}>
                                <button onClick={() => {setVipCode(''); setVipCodeError(''); setVipCodeCheckOpen(false); clearSelectedVehicle()}}
                                        className='btn btn-primary btn-all btn-block mt-2' style={{marginRight: 10}}>{translateService.translate('vehicleSearch1.cancel')}</button>
                                <button onClick={() => {vipCode.length < 5 || vipCode.length > 15 ? setVipCodeError(translateService.translate('vehicleSearch1.invalidCode')) :
                                    setBusyValidating(true); validateVipCode(vipCode)}} className='btn btn-primary btn-all btn-block mt-2'>{translateService.translate('vehicleSearch1.send')}</button>
                            </div>
                        </div> }
                </Modal>
                : null
            }
        </div>

    )
};

export function checkVipCodeValid(vehicleId: number, vip: boolean | undefined, validatedVipVehicles: string | undefined) {
    if(vip && validatedVipVehicles && validatedVipVehicles.length) {
        return validatedVipVehicles.split(',').includes(vehicleId.toString());
    }
    return false;
}

// note: this file can be condensed a bit in future some of the similar code pieced shared between components -- but will require some time to change around #todo
